import { assocPath, reduce } from 'ramda';

export const convertArrayToObjectByKey = <
  L extends { [key: string]: any },
  K extends keyof L
>(
  list: L[],
  key: K
): Record<L[K], L> =>
  reduce<L, Record<L[K], L>>(
    (acc, item) => assocPath([item[key]], item, acc),
    {} as Record<L[K], L>,
    list
  );
